<table width="100%">
  <tr>
    <td>
      <span class="nbr">Nombre d'elements: {{elementsNbr}}</span>
    </td>
    <!-- <td class="text-right">
      <button class="button-mode" *ngIf="chosenOrderType>0" (click)="changeMode()">
        <span *ngIf="elementsNbr>0 && updatePanier"> {{orderTypLabel}} </span>
      </button>
    </td> -->
  </tr>
</table>
<div class="separator"></div>
<div class="list" [class.overf]="!btnValidate">
  <table width="100%">
    <tbody *ngFor="let el of order?.elements;let i=index" [class.ical]="bounceIn">
      <tr class="space"></tr>
      <tr valign="top">
        <td width="40px">
          <img [src]="el.avatar|absolutePath:'products'" class="w3-bar-item w3-circle w3-hide-small product-avatar">
        </td>
        <td class="pl-25 element">
          <span>
            <button class="moins" *ngIf="updatePanier"  (click)="decrQty(i,0)">
              <img src="assets/images/icons/moins.png" class="w3-bar-item w3-circle w3-hide-small">
            </button>
            <button class="moins">{{el.qty}}</button>
            <button class="plus" *ngIf="updatePanier"  (click)="incrQty(i,0)">
              <img src="assets/images/icons/plus.png" class="w3-bar-item w3-circle w3-hide-small">
            </button>
          </span>
          <span>{{el.name}}</span><br>
          <span>({{el.size.size}} {{el.priceWithSupp | number : '1.2-2' | helpycurrency}})</span><br>
          <span class="supp" *ngIf="el.removedCompositions?.length>0">
            <span class="ingTitle">sans :</span>
            <ul>
              <li *ngFor="let comp of el.removedCompositions">
                <span>{{comp.label}} </span>
              </li>
            </ul>
          </span>
          <span class="supp" *ngIf="el.optionIngredients?.length>0">
            <span class="ingTitle">options :</span>
            <ul>
              <li *ngFor="let opt of el.optionIngredients">
                <span>{{opt.label}} </span>
              </li>
            </ul>
          </span>
          <span class="supp" *ngIf="el.supplements?.length>0">
            <span class="ingTitle">supp :</span>
            <ul>
              <li *ngFor="let supp of el.supplements">
                <span>{{supp.label}} ( {{supp.price | helpycurrency}})</span>
              </li>
            </ul>
          </span>
          <span class="supp" *ngIf="el.comment">
            <span class="ingTitle">Commentaire :</span>
            <span>{{el.comment}}</span>
          </span>
        </td>
        <td width="40px" class="text-right">
          <span>
            <i id="editP" class="flaticon-edit-document" *ngIf="updatePanier && el.canUpdate" role="button"
              (click)="updateElement(i)"></i>
          </span>
          <span class="trash">
            <i class="flaticon-garbage"  *ngIf="updatePanier" (click)="removeElement(i,0)"></i>
          </span>
        </td>
      </tr>
      <tr class="tr-price">
        <td width="40px">
        </td>
        <td class="pl-25">
        </td>
        <td width="50px" class="text-right">
          <span class="price">{{el.total | number : '1.2-2'  | helpycurrency}}</span>
        </td>
      </tr>
    </tbody>
    <tbody *ngFor="let menu of order?.menus;let i=index" [class.ical]="bounceIn">
      <tr class="space"></tr>
      <tr valign="top">
        <td width="40px">
          <img [src]="menu.avatar|absolutePath:'menus'" class="w3-bar-item w3-circle w3-hide-small product-avatar">
        </td>
        <td class="element-title element pl-25">
          <span> {{menu.title}} </span>
          <span *ngIf="menu.offer==null">{{menu.priceWithSupp | number : '1.2-2' | helpycurrency}} </span>
          <ul>
            <li *ngFor="let el of menu?.elements;let i=index">
              <span>{{el.name}}</span>
              <br>
              <span *ngIf="el.size.level>0">({{el.size.label}})</span> <br *ngIf="el.size.level>0">
              <span class="supp" *ngIf="el.removedCompositions?.length>0">
                <span class="ingTitle">sans :</span>
                <ul>
                  <li *ngFor="let comp of el.removedCompositions">
                    <span>{{comp.text}} </span>
                  </li>
                </ul>
              </span>
              <span class="supp" *ngIf="el.optionIngredients?.length>0">
                <span class="ingTitle">options :</span>
                <ul>
                  <li *ngFor="let opt of el.optionIngredients">
                    <span>{{opt.text}} </span>

                  </li>
                </ul>
              </span>
              <span class="supp" *ngIf="el.supplements?.length>0">
                <span class="ingTitle">supp :</span>
                <ul>
                  <li *ngFor="let supp of el.supplements">
                    <span>{{supp.text}} ( {{supp.price | helpycurrency}})</span>
                  </li>
                </ul>
              </span>
            </li>
            <li *ngFor="let el of menu?.additionalOptions">
              {{el.name}} ({{el.size}} {{el.price | helpycurrency}})
            </li>
          </ul>
          <p>{{menu.comment}}</p>
        </td>
        <td width="40px" class="text-right">
          <span class="trash">
            <i class="flaticon-garbage"  *ngIf="updatePanier" (click)="removeElement(i,1)"></i>
          </span>
        </td>
      </tr>
      <tr class="tr-price">
        <td width="40px">
        </td>
        <td class="pl-25">
        </td>
        <td width="50px" class="text-right">
          <span class="price"> {{menu.total | number : '1.2-2' | helpycurrency}}</span>
        </td>
      </tr>
    </tbody>
  </table>
  <table>
    <tbody>
      <tr class="space"></tr>
      <tr *ngIf="order.discount>0 || order.coupon>0">
        <td class="substotal">Sous-total :</td>
        <td class="substotal text-right">{{order.amount | number : '1.2-2'}} €</td>
      </tr>
      <tr *ngIf="order.discount>0">
        <td class="substotal">Remise {{order.discount}}% :</td>
        <td class="substotal text-right">{{order.discountValue | number : '1.2-2'}} €</td>
      </tr>
      <tr *ngIf="order.coupon>0">
        <td class="substotal">
          Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
          <ng-container *ngIf="order.couponType==2">%</ng-container> :
        </td>
        <td class="substotal text-right">{{order.couponValue | number : '1.2-2'}} €</td>
      </tr>
      <tr *ngIf="order.fees>0">
        <td class="substotal">{{order.feesLabel}} :</td>
        <td class="substotal text-right">{{order.fees | number : '1.2-2'}} €</td>
      </tr>
      <tr>
        <td class="total">TOTAL TTC:</td>
        <td class="total text-right">
          {{order.total | number : '1.2-2'}} €
        </td>
      </tr>
      <tr class="space"></tr>
    </tbody>
  </table>
</div>
<ng-template #template>
  <div class="modal-body text-center">
    <p>
      <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
    </p>
    <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
    <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
    <button type="button" class="btn btn-default" (click)="confirm()">OUI</button>
    <button type="button" class="btn btn-template" (click)="decline()">NON</button>
  </div>
</ng-template>